import { P2GBox } from '@parcel2go/core-ui';
import { P2GButtonGroup, P2GButtonGroupItem } from '@parcel2go/core-ui';
import { ReactNode, useState } from 'react';
import {
  PaymentOptionApiModel,
  PaymentOptionOptionApiModel,
  PaymentOptionType,
  ShipResponse
} from '~/lib/api/smartsend/types';
import { chunk } from '../../../../lib/helpers/ArrayHelper';
import { ProviderGroup, ProviderGroupState } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import ProviderGroupSummary from './ProviderGroupSummary';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  providerGroups: ProviderGroup[];
  onClose: () => void;
  book: (x: ProviderGroup) => void;
  removeItems: (ids: string[]) => void;
  markAsDispatched: (x: ProviderGroup) => void;
  getPaymentOptions: (x: ProviderGroup) => PaymentOptionApiModel[];
  updateDiscountCode: (key: string, discountCode: string) => void;
  canInstantPay: boolean;
  isXs: boolean;
  confirmComponent: ReactNode;
  setProviderGroups: (key: string, option: PaymentOptionType, optionOption: PaymentOptionOptionApiModel) => void;
  onBooked: (g: ProviderGroup) => void;
  setState: (
    group: ProviderGroup,
    state: ProviderGroupState,
    shipResponse: ShipResponse,
    markAsDispatched: boolean
  ) => ProviderGroup[];
}

const ProviderGroups: React.FC<props> = (props) => {
  const [visible, setVisible] = useState(0);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    <div>
      {props.providerGroups.length > 1 && (
        <>
          {chunk(props.providerGroups, 5).map((g, gi) => (
            <P2GBox mb={1} key={`${gi}`}>
              <P2GButtonGroup fullWidth>
                {g.map((x, i) => {
                  const index = gi * 5 + i;
                  return (
                    <P2GButtonGroupItem
                      key={`${index}`}
                      selected={visible.toString()}
                      value={index.toString()}
                      onClick={() => setVisible(index)}
                    >
                      {t('ORDER_COUNT_DISPLAY_BUTTON', { defaultValue: 'Order {{count}}', count: index + 1 })}
                    </P2GButtonGroupItem>
                  );
                })}
              </P2GButtonGroup>
            </P2GBox>
          ))}
        </>
      )}
      {props.providerGroups.map((x, i) => (
        <ProviderGroupSummary
          key={x.Key}
          totalGroups={props.providerGroups.length}
          removeItems={props.removeItems}
          visible={i === visible}
          close={props.onClose}
          group={x}
          book={() => props.book(x)}
          getPaymentOptions={() => props.getPaymentOptions(x)}
          updateDiscountCode={(d) => props.updateDiscountCode(x.Key, d)}
          updateSelectedPaymentOption={(option, optionOption) => props.setProviderGroups(x.Key, option, optionOption)}
          updateState={(state) => props.setState(x, state, null, false)}
          reset={() => props.setState(x, 'IDLE', null, false)}
          markAsDispatched={() => props.markAsDispatched(x)}
          confirmComponent={props.confirmComponent}
          onBooked={() => props.onBooked(x)}
          hidePay={props.canInstantPay}
          isXs={props.isXs}
        />
      ))}
    </div>
  );
};

export default ProviderGroups;
